import { classifyGroupAction, groupIssues, type EligibilityVerdict } from '@hit-game/shared/utils';
import { AccountRunStatus } from '@hit-game/shared/enums';
import type { BulkGroupAction, IAccountDataResponse, IGroup } from '@hit-game/shared/types';

/**
 * Điều kiện `start`/`stop` của một nhóm, tính ở PHÍA WEB để preview.
 *
 * Luật thì dùng CHUNG với server (`classifyGroupAction` trong gói shared) — ở
 * đây chỉ dựng `ctx` từ dữ liệu web có sẵn: trạng thái chạy suy từ
 * `account.status`, đăng nhập suy từ `account.isLoggedIn`. Server vẫn là nguồn
 * sự thật (nó đọc `runners` + token2 thật); nếu hai bên lệch, server skip đúng.
 */
export type GroupEligibility = Record<BulkGroupAction, EligibilityVerdict>;

/** Gom account theo id một lần để nhiều thẻ/nhiều nhóm khỏi dựng lại map. */
export function indexAccountsById(
  accounts: IAccountDataResponse[],
): Map<string, IAccountDataResponse> {
  return new Map(accounts.map((account) => [String(account._id), account]));
}

export function groupEligibility(
  group: IGroup,
  accountsById: Map<string, IAccountDataResponse>,
): GroupEligibility {
  const members = group.members.map((member) => accountsById.get(String(member.accountId)));
  const ctx = {
    running: members.some((account) => account?.status === AccountRunStatus.RUNNING),
    allLoggedIn: group.members.length > 0 && members.every((account) => account?.isLoggedIn === true),
    issues: groupIssues({
      gameType: group.gameType,
      memberCount: group.members.length,
      sideConfigs: group.sideConfigs,
    }),
  };

  return {
    start: classifyGroupAction('start', ctx),
    stop: classifyGroupAction('stop', ctx),
  };
}
